import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import demo from '../../img/home/casks-demo.jpg';
import './DistilleryManagementDemo.css';

class DistilleryManagementDemo extends Component {
  render() {
    return (
      <div className="distillery-management-demo">
        <Grid>
          <Row className="platform">
            <Col md={1} xs={12} />
            <Col md={10} xs={12}>
              <Fade delay={100}>
                <h1> Distillery Management Platform </h1>
              </Fade>
              <Fade delay={300}>
                <p>
                  The Distilled ID platform helps you manage every aspect of your distillery
                  from the arrival of stock through spirit production and storage, right up
                  to bottling and distribution.
                </p>
              </Fade>
              <Fade delay={500}>
                <p>
                  Using our unique blockchain enabled service, you can track every step of
                  your process and verify the integrity and validity of the data. Sharing
                  this data with your customers using our “Storybook” interface helps
                  improve trust in your brand while also creating a connection with your
                  product’s consumers in a way that was previously impossible.
                </p>
              </Fade>
              <Fade delay={700}>
                <a href="/contact" className="blue-link">
                  <h3 className="blue-link-arrow">Schedule a demo</h3>
                </a>
              </Fade>
            </Col>
            <Col md={1} xs={12} />
          </Row>
          <Fade>
            <Row>
              <Col md={12} xs={12} className="placeholder">
                <div className="screenshot-wrapper" id="image">
                  <img src={demo} className="img-responsive" alt="Inside Distillery Management Platform - Cask Management" />
                </div>
              </Col>
            </Row>
          </Fade>
          <Row className="feature-row ">
            <Fade delay={200}>
              <Col md={4} xs={12} className="feature"> <h1>Alerting/Reporting</h1>
                <p className="feature-description">
                  Keep track of your processes and receive notifications if issues are detected
                </p>
              </Col>
            </Fade>
            <Fade delay={700}>
              <Col md={4} xs={12} className="feature"> <h1>Cask Management</h1>
                <p className="feature-description">
                  Track the full history of your casks including origin, seasoning and fill counts
                </p>
              </Col>
            </Fade>
            <Fade delay={1200} >
              <Col md={4} xs={12} className="feature"> <h1>HMRC</h1>
                <p className="feature-description">
                  Automatically generate HMRC compliance forms pre-filled with production data
                </p>
              </Col>
            </Fade>

          </Row>
        </Grid>
      </div>
    );
  }
}

export default DistilleryManagementDemo;




// WEBPACK FOOTER //
// ./src/components/common/DistilleryManagementDemo.js